import { render, staticRenderFns } from "./expert-top-list.vue?vue&type=template&id=5fa263f8&scoped=true&"
import script from "./expert-top-list.vue?vue&type=script&lang=js&"
export * from "./expert-top-list.vue?vue&type=script&lang=js&"
import style0 from "./expert-top-list.vue?vue&type=style&index=0&id=5fa263f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa263f8",
  null
  
)

export default component.exports